export default __webpack_public_path__ + "static/media/040-no entry.606b7596.png";